module.exports = __webpack_public_path__ + "img/santos.0f7bf725.svg";